module.exports = __webpack_public_path__ + "img/polis.6af547e4.svg";